const blog_swiper = new Swiper(".blog-slider", {
    pagination: {
        el: ".swiper-pagination-blog-slider",
        clickable: true,
    },
    slidesPerView: '1',
    keyboard: true,
    paginationClickable: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 25,
        },
    },
});

const blogstart_swiper = new Swiper(".blog-slider-start", {
    pagination: {
        el: ".swiper-pagination-blog-slider",
        clickable: true,
    },
    slidesPerView: '1',
    keyboard: true,
    paginationClickable: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 25,
        },
        1100: {
            slidesPerView: 3,
            spaceBetween: 25,
        },
    },
});

const verkaufspferde_swiper = new Swiper(".verkaufspferde-start", {
    pagination: {
        el: ".swiper-pagination-verkaufspferde",
        clickable: true,
    },
    slidesPerView: '1',
    keyboard: true,
    paginationClickable: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 25,
        },
        1100: {
            slidesPerView: 3,
            spaceBetween: 25,
        },
    },
});